<div class='home-outer'>
  <div class='home-inner'>

    <div class="home-cells">

      <div class="cell-row">
        <hex-cell class="home-column col0" background="/assets/img/home-page/cell-exhibition.jpg" url="/exhibition">{{ 'menu.exhibition' | translate }}</hex-cell>
        <hex-cell class="home-column col1" background="/assets/img/home-page/cell-painting.jpg" url="/painting">{{ 'menu.painting' | translate }}</hex-cell>
      </div>

      <div class="cell-row">
        <hex-cell class="home-column col0" background="/assets/img/home-page/cell-photo.jpg" url="/photo">{{ 'menu.photo' | translate }}</hex-cell>
        <hex-cell class="home-column col1 zi1" background="/assets/img/home-page/velryba-video-240.gif" url="/installation">{{ 'menu.installation' | translate }}</hex-cell>
        <hex-cell class="home-column col2 label-70" background="/assets/img/home-page/cell-bio2.jpg" url="/bio">{{ 'menu.bio' | translate }}</hex-cell>
      </div>

    </div>

  </div>
</div>
